@if (showScenarioButton || showHospitalButton) {
    <lg-dropdown
        className="lg-breadcrumb-data-context__dropdown"
        [textOverride]="'.Switch' | lgTranslate"
        [definition]="_dropdownDef"
        (currentChange)="_switch($event)"
        [hideArrow]="true"
        [hideSearch]="true"
        [matchWidth]="'content'"
    ></lg-dropdown>
}

@if (!hideHospital) {
    <span
        class="lg-breadcrumb-data-context__hospital"
        (click)="_switchHospital()"
        (keydown.enter)="_switchHospital()"
        tabindex="0"
        >{{ _userInfo.ziekenhuisnaam }}</span
    >
}
@if (_version && !hideScenario && !!_version.scenario_naam) {
    <span class="lg-breadcrumb-data-context__version">
        {{ "Scenario" | lgTranslate }}:
        <span
            class="lg-breadcrumb-data-context__version__name"
            (click)="_onScenarioClicked()"
            (keydown.enter)="_onScenarioClicked()"
            tabindex="0"
            [lgTooltip]="_version.scenario_omschrijving ?? null"
        >
            {{ _version.scenario_naam }}
        </span>
    </span>
}

<div class="lg-breadcrumb-data-context__icons">
    @if (_version.is_primary) {
        <lg-icon
            icon="icon-star"
            [inline]="true"
            class="lg-breadcrumb-data-context__icon__star"
            [lgTooltip]="'.ThisDatasetContainsPrimaryVersion' | lgTranslate"
        ></lg-icon>
    }
    @if (_version.locked && !_version.frozen && !hideLock) {
        <lg-icon
            icon="icon-lock"
            [inline]="true"
            [lgTooltip]="'.ThisScenarioIsLocked' | lgTranslate"
        ></lg-icon>
    }
    @if (_version.frozen) {
        <lg-icon
            icon="icon-all-done"
            [inline]="true"
            [lgTooltip]="'.ThisScenarioIsFrozen' | lgTranslate"
        ></lg-icon>
    }
</div>
